import { useCallback, useEffect, useRef, useState } from "react";
import { usePermissions } from "../providers/authProvider";
import { Api } from "../api";
import { OrderData, OrderStatus } from "../../../types/order";
import { SITE_DATA_PARTITIONS } from "../../../types";
import { RequestStatus } from "./useOrder";

export type OrdersRequest = {
  status: RequestStatus;
  orders?: OrderData[];
  // shipmentsRequest?: ShipmentsRequest;
  error?: any;
};
export const useOrders = ({
  startWithRequest = true,
  orderStatuses,
  permissions,
}: {
  startWithRequest?: boolean;
  orderStatuses?: OrderStatus[];
  permissions?: ReturnType<typeof usePermissions>;
}) => {
  const shouldRequestOrderData = useRef(true);
  const [ordersRequest, setOrdersRequest] = useState<OrdersRequest>({
    status: startWithRequest ? "loading" : "idle",
  });
  const request = useCallback(() => {
    if (!permissions?.loading) {
      setOrdersRequest({
        status: "loading",
      });
      const operation = orderStatuses?.length ? Api.search : Api.getAll;
        operation<OrderData>({
          type: SITE_DATA_PARTITIONS.ORDER,
          ...(orderStatuses?.length ? { orderStatus: orderStatuses } : {}),
        })
        .then((resp) =>
          resp.success
            ? setOrdersRequest((req) => ({
              status: "present" as const,
              orders: resp.body.items,
            }))
            : setOrdersRequest((req) => ({
              status: "server-error" as const,
              error: resp.error,
            }))
        )
        .catch((e) =>
          setOrdersRequest((req) => ({
            status: "request-error" as const,
            error: e,
          }))
        );
    }
  }, [permissions?.loading, setOrdersRequest, orderStatuses]);

  useEffect(() => {
    if (
      startWithRequest &&
      shouldRequestOrderData.current &&
      !permissions?.loading
    ) {
      shouldRequestOrderData.current = false;
      request()
    }
  }, [shouldRequestOrderData, request, permissions?.loading]);
  return [ordersRequest, request] as const;
};
